const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const numberToMonthName = (value: number) => {
  return monthNames[value];
};

export const formatDate = (date?: string): string => {
  if (!date) {
    return '';
  }
  return (
    numberToMonthName(new Date(date).getMonth()) +
    ' ' +
    new Date(date).getDate() +
    ', ' +
    new Date(date).getFullYear()
  );
};

export const formatDate3LetterMonth = (
  date: string | null | undefined
): string => {
  if (!date) {
    return '';
  }
  return (
    numberToMonthName(new Date(date).getMonth()).slice(0, 3) +
    ' ' +
    new Date(date).getDate() +
    ', ' +
    new Date(date).getFullYear()
  );
};

export const getTime = (date: string): string => {
  return new Date(date).toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};
export const formatDateWithTime = (date: string): string => {
  if (!date) {
    return '';
  }
  return formatDate(date) + ' ' + getTime(date);
};
